import React, { useEffect, useState } from "react";
import cancel from "assets/icon/cancel.svg";
import search from "assets/icon/search.svg";
import save from "assets/icon/save.svg";
import { Formik } from "formik";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import NDCLISTINPUT from "components/NDCLISTINPUT";
import ErrorBoundary from "components/ErrorBoundary";
import { cellRendererCheck, dateFormate } from "utils/columns";
import ReactStrapTable from "components/reactStrapTable";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import Calendar from "assets/icon/calendar-icon.svg";
import moment from "moment";
import { cloneDeep } from "lodash";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import Loader from "components/Loader";
import ChargeCodeList from "components/ChargeCodeList";
import ChargeCodeDescriptionSearch from "components/ChargeCodeDescriptionSearch";


let hasDatePopupOpen = false;
let stdateerror = 'Effective Date is a required field';
let endDateError = "Term Date must be Greater Than or Equal to EffectiveDate";
let bupperror = "BUPP is a required field";
let exchargecodeerror = "Existing Charge Code is a required field"
let chargecoderror = "Charge Code is a required field"
let chargecodedescerror = "Existing Charge Code Description is a required field"

const AddCrossWalkDrawer = (props) => {
  const { loading, handelAddMaping,setNDCMapingHistoryData, setLoading, orgId, ndcDetails, crosswalkNdcsearch,storedDate } = props;
  const API = useAxios();

  const [selectedNdc, setSelectedNdc] = useState("");
  //  const [tableData, setTableData] = useState(dummydata);
  // const [checkflag, setCheckFlag] = useState(false);
  const [selectedrow, setSelectedRow] = useState({});
  const [ndcDisc, setNdcDesc] = useState("");
  const [rSelected, setRSelected] = useState("catalog");
  const [ndctabledata, setNdcTabledata] = useState([]);
  const [ndctotalrecords, setNdcTotalRecords] = useState(0);
  const [initialValues, setInitialValues] = useState({
    ...crosswalkNdcsearch,
  });
  const [startDate, setstartDate] = useState(null);
  const [termdate, setTermDate] = useState(null);
  const [bupp, setBupp] = useState(0);
  const [notes, setNotes] = useState("");
  const [err, setErr] = useState("");
  const [error, seterror] = useState(false);
  //const [chargeDisc, setChargeDesc] = useState('');
  const [chargeCode, setChargeCode] = useState("");
   const [loder, setloder] = useState(false);
   const [chargecodehideerror, setChargecodehideerror] = useState('');
  useEffect(() => {
    if (ndcDetails) {
      setSelectedNdc(ndcDetails?.ndc)
      setNdcDesc(ndcDetails?.drugDescription)

    }
  }, [ndcDetails])

  const handleEffectiveDateRaw = (e) => {
    var val = e.target.value;

    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && startDate !== null) {
      setstartDate(null);
    }

    if (isValid) {
      handleStartDate(e.target.value);
    }
  };
  const fetchmapingHistory = async (rowData) => {
    debugger;
    let ndc = rowData?.NDC
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId?.tenantID}/Crosswalk/NdcMappingHistory/${ndc}`,crosswalkNdcsearch,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
      setNDCMapingHistoryData(data.items);
      setLoading(false);
      }
      else{
            setNDCMapingHistoryData([]);
         setLoading(false);
      }
       setLoading(false);
    } catch {
      setLoading(false);
    }
  }
  const handleTermDateRaw = (e) => {
    var val = e.target.value;

    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && startDate !== null) {
      setTermDate(null);
    }
    if(val==""){
      setTermDate(null)
    }

    if (isValid) {
      handletermdate(e.target.value);
    }
  };
  const handletermdate = (e) => {
    // const enddate = e.target.value;
    // //    // var dt = moment(stDate, "MM/DD/YYYY", true);
    if(e==null){
      setTermDate(null)
    }
    else{
    setTermDate(new Date(e));
    }

    if (error == false) {
      seterror(false);
    }
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleSubmit = async () => {
    debugger;
    setloder(true);
    if ((chargeCode.code == '' || chargeCode.code == undefined) || bupp == 0 || startDate == null || (termdate != null && (new Date(termdate) < new Date(startDate)))) {
      setloder(false);
      return seterror(true);
    }
    else {
      let payload = {};
      payload.Chargecode = chargeCode.code;
      payload.NDC = selectedNdc;
      //payload.ChargeDescription = chargeDisc;
      payload.ChargeDescription = chargeCode.description;
      payload.BUPP = bupp;
      payload.Notes = notes;
      payload.DrugDescription = ndcDisc;
      payload.AccumulatorID = ndcDetails?.accumulatorID;
      payload.StartDate = moment(startDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
      if (termdate != null) {
        payload.EndDate = moment(termdate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
      }
      else {
        payload.EndDate = null;
      }
      payload.ChargeID = 0;
      try {
        const { data } = await API.post(`SBTenant/${orgId.tenantID}/CrossWalk/NewMapping`, payload,
          { hasDefaultURL: true, }
        )
        if (data == true) {
          handelAddMaping();
          toast.success('Mapped successfully');
          fetchmapingHistory(payload);
          //  setErr(data.message)
          // toast.error(data.message);
          setloder(false);
          //addCrosswalk();
        }
        else {
          setloder(false);
        }
      }
      catch {
        setloder(false);
      }
    }
  };
  const onSelectndc = async (ndc) => {
    // setErr('');
    if (ndc) {
      setSelectedNdc(ndc);
      setNdcDesc(ndc.description);

      // seterror(false);
      // if(error == false){
      //     seterror(false);

      // }
      fetchGCNHistory(ndc);
    } else {
      setSelectedNdc("");
      // setNdcDisc("");
      // if(provider == ''){
      //     setErr('');
      // }
      // if(validationarrmsg.includes(err)){
      //     setErr('');
      // }
    }
  };
  const CellSelectall = (rowData) => {
    return (
      <div className="d-flex align-items-center">{SelectButton(rowData)}</div>
    );
  };
  const SelectButton = (row) => {
    return (
      <Input
        type="radio"
        // className=''
        id="myradio"
        //value={selectedOption}
        style={{ fontSize: "18px", margin: "auto" }}
        onChange={(e) => handlecheckbox(e, row)}
        value={selectedrow}
        checked={selectedrow === row}
        className="mr-1"
      //checked={selectedOption === selectedOption}
      ></Input>
    );
  };
  const handlecheckbox = (e, row) => {
    if (e.target.checked) {
      setSelectedNdc(row.ndc);
      setNdcDesc(row.drugDescription)
      setCheckFlag(true);
      setSelectedRow(row);
    }

  };
  let mainCol = [
    {
      dataField: "Options",
      text: "Select",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => CellSelectall(row),
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: "drugDescription",
      text: "NDC Description",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.drugDescription),
    },
    {
      dataField: "packageSize",
      text: "Package Size",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.packageSize),
    },
    {
      dataField: "gcnSequenceNumber",
      text: "GCN",
      sort: false,
      width: 180,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.gcnSequenceNumber),
    },
  ];
  const onClickFilter = (toggle) => {
    setRSelected(toggle);
    fetchGCNHistory(selectedNdc);
  };
  const fetchGCNHistory = async () => {
    debugger;
    let payload = cloneDeep(unmappedchargesearch);

    payload.AccumulatorID = unmappedchargesearch.AccumulatorID;
    //let ndc = selectedNdc;

    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/GCNHistoryByNDC/${selectedNdc}/${rSelected}`,
        payload,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setNdcTabledata(data.items);
        setNdcTotalRecords(data.totalRecords);
      }
      else{
        setNdcTabledata([]);
        setNdcTotalRecords(0);
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };
  const fetchNDcDescGCNHistory = async () => {
    let payload = cloneDeep(unmappedchargesearch);

    payload.AccumulatorID = unmappedchargesearch.AccumulatorID;
    //let ndc = selectedNdc;

    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/GCNHistoryByNDC/${ndcDisc}/${rSelected}`,
        payload,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setNdcTabledata(data.items);
        setNdcTotalRecords(data.totalRecords);
      }
      else{
        setNdcTabledata([]);
        setNdcTotalRecords(0);
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      const filterObj = cloneDeep(initialValues);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      setInitialValues({
        currentPage: filter.currentPage,
        pageSize: filter.pageSize,
        ...filter,
      });
      // initialValues.currentPage = filter.currentPage;
      // initialValues.pageSize = filter.pageSize;
      // initialValues = { ...initialValues, ...filter };
      fetchGCNHistory(selectedNdc);
    } else {

      fetchGCNHistory(selectedNdc);
      setInitialValues({ ...initialValues, ...filter });
    }
    //updateStates(crosswalkQueue);
  };
  const handlebupp = (e) => {

    setBupp(e.target.value);
    if (error == false) {
      seterror(false);
    }
    //  seterror(false);
  };

  const handleStartDate = (startDate) => {
    // let stDate = startDate.toISOString();
    // //      let dt =  stDate.substring(0,10)
    // //    // var dt = moment(stDate, "MM/DD/YYYY", true);
    setstartDate(new Date(startDate));
    if (error == false) {
      seterror(false);
    }
    //  seterror(false);
  };
  const onSelectCharge = (charge) => {
    debugger;
    if (charge) {
      setChargeCode(charge);
    //  setChargeDesc(charge.description);
      fetchChargecodeCheck(charge.code);
    } else {
      setChargeCode("");
      //setChargeDesc("");
      setChargecodehideerror('');
    }
  }
   const fetchChargecodeCheck = async (chargeCode) => {
    debugger;
    setloder(true);
    let accId = crosswalkNdcsearch.AccumulatorID;
    try {
      const { data } = await API.get(
        `SBTenant/${orgId.tenantID}/CrossWalk/HiddenChargeCodeCheck/${chargeCode}/${accId}`,
        {
          hasDefaultURL: true,
        }
      );
      debugger
      if (data?.error == true) {
        setChargecodehideerror(data.message)
      }
      else{
          setChargecodehideerror('');
       }
      setloder(false);
    } catch {
      setloder(false);
    }
  };

  return (
    <div>
      <Card className="border-0 shadow-top ">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <Formik
              initialValues={""}
              onSubmit={handleSubmit}
              // validationSchema={validationSchema}
              // enableReinitialize={true}
              children={(props) => {
                const {
                  isSubmitting,
                  handleSubmit,
                  resetForm,
                  setFieldValue,
                  errors,
                  touched,
                } = props;
                return (
                  <div className="addcrooswalk">
                    <Row>
                      <Col md={6}>
                        <Label style={{}}>Existing Charge Code</Label>
                        <ChargeCodeList
                          tenantID={orgId.tenantID}
                          onSelect={onSelectCharge}
                          selectedProvider={chargeCode}
                          acid={crosswalkNdcsearch.AccumulatorID}
                        />
                        {error && (chargeCode == '' || chargeCode == null) ? (
                          <div className="text-danger f-12"
                            style={{ fontWeight: "bold" }}>
                            {exchargecodeerror}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label
                            htmlFor="chargecodedesc" for='chargecodedesc'
                          // className={focusedInput === 'Application' ? 'label-focus' : 'required'}
                          > Existing Charge Code Description</Label>
                          {/* <Input name="chargecodesc"
                            className="required"
                             placeholder="Enter Charge Code Description"
                            value={chargeDisc}
                            //disabled={chargeDisc ? true : false}
                             /> */}
                               <ChargeCodeDescriptionSearch
                          tenantID={orgId.tenantID}
                          onSelect={onSelectCharge}
                          selectedProvider={chargeCode}
                          acid={crosswalkNdcsearch.AccumulatorID}
                        />
                          {/* {error && (chargeDisc == "" || chargeDisc == null) ? (
                            <div className="text-danger f-12"
                              style={{ fontWeight: "bold" }}>
                              {chargecodedescerror}
                            </div>
                          ) : null} */}
                          {error && (chargeCode == '' || chargeCode == null) ? (
                          <div className="text-danger f-12"
                            style={{ fontWeight: "bold" }}>
                            {chargecodedescerror}
                          </div>
                        ) : null}
                        </FormGroup>

                      </Col>

                    </Row>
                      {loder && <Loader opacity={0.01} />}
                    <div style={{
                      border: "1px solid #D3D3D3",
                      borderRadius: "4px",

                      marginTop: "10px"
                    }}>
                      <Row
                        className="mt-2 p-3"
                        style={{ border: "1px solid #FEFEFE" }}
                      >
                        <div>
                          <h3
                            className="f-16 font-weight-600"
                            style={{ color: "#702C62" }}
                          >
                            Other Details
                          </h3>
                        </div>
                         {loder && <Loader opacity={0.01} />}
                        <div>
                          <Row>
                            <Col md="4">
                              <p className="m-0 f-14 ">Last Invoice Date</p>
                              <p className="m-0 f-14 font-weight-600 mt-1">{dateFormate(ndcDetails?.lastInvoicedDate)}</p>
                            </Col>
                            <Col md="4">
                              <p className="m-0 f-14 ">Package Size</p>
                              <p className="m-0 f-14 font-weight-600 mt-1">{ndcDetails?.packageSize}</p>
                            </Col>
                            <Col md="4">
                              <p className="m-0 f-14 ">Last Invoiced Qty</p>
                              <p className="m-0 f-14 font-weight-600 mt-1">{ndcDetails.lastInvoicedQty}</p>
                            </Col>

                          </Row>
                        </div>


                      </Row>
                    </div>
                     
                    <Row className="mt-1">
                      <Col md={6} className="purchase-date-addcrosswalk">
                        <Label>Effective Date</Label>
                        <FormGroup>
                          <InputGroup
                            onMouseLeave={handleMouseLeave}
                            className="required"
                          >
                            <DatePicker
                              type="date"
                              id="startDate"
                              selected={startDate}
                              onChange={handleStartDate}
                              minDate={new Date(storedDate)}
                              placeholderText="select a date"
                              name="startDate"
                              onChangeRaw={handleEffectiveDateRaw}
                              dateFormat="MM/dd/yyyy"
                              onKeyDown={(e) => e.preventDefault()}
                              autoComplete="off"
                              // customInput={
                              //   <ReactInputMask
                              //     mask="99/99/9999"
                              //     // minDate={new Date(orderDate)}
                              //     // value={startDate}
                              //     // maskChar=''
                              //   />
                              // }
                              // placeholderText={placeholder}
                              className="border-0 w-100 date-picker "
                            />
                            <InputGroupText
                              onClick={() => handleDateClick("startDate")}
                            >
                              <img src={Calendar} alt="" />
                            </InputGroupText>
                          </InputGroup>
                          {(error && startDate == null) ? (
                            <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                              {stdateerror}
                            </div>
                          ) : null}
                        </FormGroup>

                      </Col>
                      <Col md={6} className="purchase-date-addcrosswalk ">
                        <Label>Term Date</Label>
                        <FormGroup>
                          <InputGroup
                            onMouseLeave={handleMouseLeave}
                            className="required"
                          >
                            <DatePicker
                              type="date"
                              id="termdate"
                              openToDate={startDate != null ? new Date(startDate) : false}
                              minDate={startDate != null ? new Date(startDate) : false}
                              selected={termdate}
                              onChange={handletermdate}
                              placeholderText="select a date"
                              name="termdate"
                              isClearable
                              onChangeRaw={handleTermDateRaw}
                              dateFormat="MM/dd/yyyy"
                              onKeyDown={(e) => e.preventDefault()}
                              autoComplete="off"
                              // customInput={
                              //   <ReactInputMask
                              //     mask="99/99/9999"
                              //     // minDate={new Date(orderDate)}
                              //     // value={startDate}
                              //     // maskChar=''
                              //   />
                              // }
                              // placeholderText={placeholder}
                              className="border-0 w-100  "
                            />
                            <InputGroupText
                              onClick={() => handleDateClick("termdate")}
                            >
                              <img src={Calendar} alt="" />
                            </InputGroupText>
                          </InputGroup>
                          {termdate != null && (termdate < startDate) ? (
                            <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                              {endDateError}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <Label>BUPP</Label>
                        <FormGroup>
                          <Input
                            type="text"
                            className="required"
                            name="bupp"
                            placeholder="Enter BUPP"
                            onChange={handlebupp}
                            autoComplete="off"
                          />
                          {(error && bupp == 0) ? (
                            <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                              {bupperror}
                            </div>
                          ) : null}
                        </FormGroup>

                      </Col>
                      <Col md={6}>
                        <Label>Comments</Label>
                        <FormGroup>
                          <Input
                            type="text"
                            className=""
                            name="notes"
                            value={notes}
                            placeholder="Enter Comments"
                            autoComplete="off"
                            onChange={(e) => setNotes(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {chargecodehideerror != "" && <div className="text-danger f-12"
                      style={{ fontWeight: "bold" }}>
                      {chargecodehideerror}
                    </div>}
                    <Row>
                      <Col
                        md={12}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div>
                          <div className="mt-3">
                            <Button
                              color="primary"
                              className="search"
                              onClick={handleSubmit}
                              disabled={chargecodehideerror != ''}
                            >
                              <span className="right_5">
                                <img src={save} alt="" />
                              </span>{" "}
                              Save
                            </Button>{" "}
                            <Button
                              color="primary"
                              className="reset"
                              onClick={handelAddMaping}
                            >
                              <span className="right_5">
                                <img src={cancel} alt="" />
                              </span>{" "}
                              Cancel
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                );
              }}
            ></Formik>
          </ErrorBoundary>
        </CardBody>
      </Card>
    </div>
  );
};

export default AddCrossWalkDrawer;
